import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center border-t border-gray-800" data-id="element-93">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <p className="font-bold text-gray-300 mb-4" data-id="element-95">
          Material educativo profesional.
        </p>
        <p className="text-sm leading-relaxed max-w-2xl mx-auto" data-id="element-96">
          Este es material educativo de apoyo profesional. No reemplaza la
          formación académica ni la supervisión profesional. Diseñado para uso
          en contextos educativos formales en Argentina.
        </p>
        <div className="mt-8 text-xs text-gray-600" data-id="element-97">
          &copy; {new Date().getFullYear()} MegaPack Psicopedagogía. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}